
import { browserHistory } from 'react-router'
import THREE from 'particlespace-graphics-engine'

import { modal } from '../utilities/modal'
import { buildingControllers } from './BuildingControllers';

var ActiveLevelTempetureReadingsManager = Class.create({
    activeTempMesh: [],
    activeTimeouts: [],
    immediateRun: false,
  	initialize: function() {
    },
    setDataWithScene: function(mesh, context, scene, camera, level) {
        this.activeTempMesh.push({
            model: mesh,
            level: level,
            timeout: null,
            renderer: context.context.state.renderer,
            scene: scene,
            camera: camera,
            uuid: mesh.uuid
        });
    },
    clearWindowTimeouts: function() {
        this.activeTimeouts.forEach(timeout => {
            window.clearTimeout(timeout);
        });
        this.activeTimeouts = [];
        this.immediateRun = false;
    },
    displayAvgTempPerFloor: function() {
        var self = this;
        this.activeTempMesh.forEach(tempMesh => {
            var timeout = window.setInterval(function(){
                if(buildingControllers.tempTallyPerFloor.length > 0) {
                    const avgTmp = buildingControllers.determineAvgTempPerFloor(tempMesh.level);
                    var textCanvas = document.createElement('canvas');
                    var textContext = textCanvas.getContext('2d');
                    textContext.font = "Bold 20px Arial";
                    textContext.fillStyle = "rgb(14, 71, 104)";
                    textContext.fillText(avgTmp, 0, 50);
                    // canvas contents will be used for a texture
                    var texture = new THREE.Texture(textCanvas)
                    texture.needsUpdate = true;

                    tempMesh.model.material.map = texture;
                    tempMesh.renderer.render( tempMesh.scene, tempMesh.camera );
                }
            }, 10000);

            self.activeTimeouts.push(timeout);
        });
    },
    displayAvgTempPerFloorImmediately: function() {
        if(this.immediateRun) {
            return;
        }
        this.activeTempMesh.forEach(tempMesh => {
            if(buildingControllers.tempTallyPerFloor.length > 0) {
                const avgTmp = buildingControllers.determineAvgTempPerFloor(tempMesh.level);
                var textCanvas = document.createElement('canvas');
                var textContext = textCanvas.getContext('2d');
                textContext.font = "Bold 20px Arial";
                textContext.fillStyle = "rgb(14, 71, 104)";
                textContext.fillText(avgTmp, 0, 50);
                // canvas contents will be used for a texture
                var texture = new THREE.Texture(textCanvas)
                texture.needsUpdate = true;

                tempMesh.model.material.map = texture;
                tempMesh.renderer.render( tempMesh.scene, tempMesh.camera );
            }
        });

        this.immediateRun = true;
    },
    clearAll: function() {
        this.activeTempMesh = [];
        this.clearWindowTimeouts();
    }
});

export let activeLevelTempetureReadingsManager = new ActiveLevelTempetureReadingsManager();


// WEBPACK FOOTER //
// app/core/controllers/ActiveLevelTempetureReadingsManager.js